<p-card class="card text-center" >
    <div class="percentage" *ngIf="product.isOnDiscount">
      <p class="m-auto font-bold" style="font-size:12px;min-width: 30px; line-height: 30px;">- {{product.percentage}}%</p>
    </div>
    <a [routerLink]="['/product-catalog/detail', this.product.id, this.product.category]">
        <img [src]="product.image" alt="" style="max-width: 100%; max-height: 9rem;" (click)="detail()">
    </a>
    <p-button *ngIf="showFavorites && user" class="custom-position"  styleClass="p-button-rounded p-button-text" (click)="loved(product)">
        <i [ngClass]="getClassList()" style="color: #708090"></i>
    </p-button>
</p-card>
<div class="text-center">
    <p style="overflow: hidden; white-space: nowrap; margin: 5px 0px 0px 0px; color: #606060;text-overflow: ellipsis !important;" (click)="detail()">{{product.productName}}</p>
    <hr style="height: 2px; background-color: var(--primary-color); width: 30%; border: 0px; margin-top: 3px;">
    <p class="text-sm line-through my-1" style="margin: 0;color: #606060;"> {{product.isOnDiscount ? (product.price | currency:'COP':'symbol-narrow':'1.0-0') : " "}} </p>
    <p style="margin: 0; color: var(--primary-color);"> {{product.isOnDiscount ? (product.priceDiscount | currency:'COP':'symbol-narrow':'1.0-0') : (product.price | currency:'COP':'symbol-narrow':'1.0-0') }} </p>
    <p-button *ngIf="1!=1" label="Añadir carrito" [style]="{color: 'black'}" styleClass="p-button-secondary p-button-text" (click)="addCar()"></p-button>
</div>

<app-shopping-car-modal *ngIf="addProductCar" [visible]="addProductCar" [product]="product"  (noVisible)="handleEvent($event)"></app-shopping-car-modal>
